// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggle__label {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.toggle__input {
  opacity: 0;
  width: 0;
  height: 0;
}
.toggle__input:checked + span {
  background-color: #49AE9E;
}
.toggle__input:checked + span:before {
  transform: translateX(29px);
}
.toggle__span {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #E1E1E1;
  transition: 0.3s;
  border-radius: 30px;
}
.toggle__span:before {
  position: absolute;
  content: "";
  height: 25px;
  width: 25px;
  left: 3px;
  bottom: 2.6px;
  background-color: #fff;
  border-radius: 50%;
  transition: 0.3s;
}`, "",{"version":3,"sources":["webpack://./src/common/toggle/toggle.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAAR;AAGI;EACI,UAAA;EACA,QAAA;EACA,SAAA;AADR;AAII;EACI,yBAAA;AAFR;AAMI;EACI,2BAAA;AAJR;AAOI;EACI,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AALR;AAQI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AANR","sourcesContent":[".toggle {\n    &__label {\n        position: relative;\n        display: inline-block;\n        width: 60px;\n        height: 30px;\n    }\n\n    &__input {\n        opacity: 0;\n        width: 0;\n        height: 0;\n    }\n\n    &__input:checked + span {\n        background-color: #49AE9E;\n        ;\n    }\n\n    &__input:checked + span:before {\n        transform: translateX(29px);\n    }\n\n    &__span {\n        position: absolute;\n        cursor: pointer;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: #E1E1E1;\n        transition: 0.3s;\n        border-radius: 30px;\n    }\n\n    &__span:before {\n        position: absolute;\n        content: '';\n        height: 25px;\n        width: 25px;\n        left: 3px;\n        bottom: 2.6px;\n        background-color: #fff;\n        border-radius: 50%;\n        transition: 0.3s;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
